var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import clsx from 'clsx';
import { createStyles, makeStyles } from '@hawkins/styles';
var useTriggerContainerStyles = makeStyles(function (theme) {
    var hawkins = theme.hawkins, hawkinsVariables = theme.hawkinsVariables;
    return createStyles({
        root: {
            position: 'relative',
        },
        active: {
            '&:after': {
                content: '""',
                display: 'block',
                position: 'absolute',
                borderColor: hawkins.focus.borderColorRegular,
                borderRadius: hawkinsVariables.borderRadius.borderRadius1,
                borderStyle: 'solid',
                borderWidth: 2,
                pointerEvents: 'none',
                top: -4,
                left: -4,
                bottom: -4,
                right: -4,
            },
        },
    });
}, { name: 'Hawkins-TriggerContainer' });
export var TriggerContainer = function (props) {
    var _a;
    var _b = props.disableActiveStyling, disableActiveStyling = _b === void 0 ? false : _b, active = props.active, className = props.className, innerRef = props.innerRef, rest = __rest(props, ["disableActiveStyling", "active", "className", "innerRef"]);
    var classes = useTriggerContainerStyles();
    var finalClassName = clsx(className, classes.root, (_a = {},
        _a[classes.active] = active && !disableActiveStyling,
        _a));
    return _jsx("div", __assign({ className: finalClassName, ref: innerRef }, rest));
};
TriggerContainer.displayName = 'TriggerContainer';
